import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Lock, LogIn, RefreshCw } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import Button from '../components/Button';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const from = (location.state && location.state.from) || '/register';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      toast.error('Enter your username and password');
      return;
    }
    setLoading(true);
    try {
      await login(username.trim(), password);
      toast.success('Signed in');
      navigate(from, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.error || 'Login failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md animate-fade-up">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-gradient-to-b from-primary-400 to-primary-600 flex items-center justify-center shadow-glow">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-title1 text-white">Gym Lockers</h1>
          <p className="text-secondary text-subheadline mt-1">Staff sign in</p>
        </div>

        <form onSubmit={handleSubmit} className="glass-sheet p-7 space-y-5">
          <div>
            <label className="block text-footnote text-label mb-1.5">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              className="input"
              placeholder="admin"
            />
          </div>
          <div>
            <label className="block text-footnote text-label mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="input"
              placeholder="Your password"
            />
          </div>
          <Button type="submit" variant="primary" className="w-full py-3 text-body" disabled={loading}>
            {loading ? (
              <><RefreshCw className="w-5 h-5 animate-spin mr-2" /> Signing in...</>
            ) : (
              <><LogIn className="w-5 h-5 mr-2" /> Sign in</>
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
